import React from 'react';
import { connect } from 'react-redux';

import {
  workflowReviewAddApprover,
  workflowSetReviewPhaseDescription,
} from '~/actions/workflow';
import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import { getReviewPhaseById } from '~/reducers/workflow';
import Box from '~/ui/components/Box/Box';
import { toSnakeTrimmed } from '~/utils/strings';
import { coerceName } from '~/utils/workflow';

import DescriptionTextAreaForm from '../../shared/DescriptionTextAreaForm';
import PhaseItem from './PhaseItem/PhaseItem';

function Phase({
  phaseId,
  position,
  // connected
  disabled,
  phase,
  workflowSetReviewPhaseDescription,
  workflowReviewAddApprover,
}) {
  const intl = useIntl();
  const coercedPhaseName = coerceName(
    phase.name,
    intl.formatMessage({
      id: 'Phase.defaultReviewPhaseName',
      defaultMessage: 'Review Phase',
      description: 'Default name for a new review phase.',
    }),
    position,
  );
  const phaseName = toSnakeTrimmed(coercedPhaseName);

  return (
    <Box disabled={disabled}>
      <Box pb={2}>
        <DescriptionTextAreaForm
          description={phase.description}
          disabled={disabled}
          id={`workflow--review-phase-name=${phaseName}-add-description`}
          onUpdate={(value) =>
            workflowSetReviewPhaseDescription({ value, phaseId })
          }
        />
      </Box>

      {phase.approvals.map((approval, index) => {
        return (
          <PhaseItem
            index={index}
            canReorder={phase.approvals.length > 1}
            phaseId={phase.id}
            approval={approval}
            key={approval.id}
          />
        );
      })}

      <Box mt={4}>
        <Button
          id={`workflow--review-phase-name=${phaseName}-add-review`}
          text={intl.formatMessage({
            id: 'Phase.addReviewButton',
            defaultMessage: 'Add Review',
            description: 'Button text for adding a review',
          })}
          onClick={() => workflowReviewAddApprover(phaseId)}
        />
      </Box>
    </Box>
  );
}

function mapStateToProps({ builder, workflow }, { phaseId }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    phase: getReviewPhaseById(workflow, phaseId),
  };
}

export default connect(mapStateToProps, {
  workflowSetReviewPhaseDescription,
  workflowReviewAddApprover,
})(Phase);
